<template>
  <div class="modal-out">
    <div class="modal">

      <div class="modal-header">
        <div class="title">曲线图</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>

      <div class="modal-body" style="padding: 10px;">

        <div style="background-color: #fff;margin: 0px 5px;">
          <div style="width: 100%;overflow: hidden;">
            <div style="text-align: center;padding: 20px">最近数据展示</div>
            <ve-line ref="chartline" :data="chartData_total_day"
                     :settings="chartSettings_total_day" :extend="chartExtend"></ve-line>
          </div>

        </div>

      </div>

    </div>
  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getGovernmentCode,} from "@/utils/auth";

export default {
  name: 'Elderly',
  data() {
    return {

      loading: false,

      showModalAdd:false,

      userCode:'',

      chartSettings_total_day:{
        labelMap:{
          createTime:"测量时间",
          value:"尿酸",
        }
      },
      chartData_total_day: {
        columns: ['createTime', 'value'],
        rows: [
          {'createTime':'1','value':'20'},
        ]
      },
      chartExtend : {
        xAxis: {
          axisLabel: {//interval: 0,
             rotate: 45, margin: 20
          }
        }
      },

      th:this.$store.state.tableHeight,
    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th=val
    },
  },
  methods: {
    init(userCode){
      this.userCode = userCode;
      this.getListData();
    },
    closeSelf() {
      this.$emit("closeLine");
    },

    timefilter(row, column, cellValue){
      return timefilters(cellValue)
    },

    getListData(){
      this.loading = true;

      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"DataAll/PageByUserCodeDeviceTypeValueType",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          deviceType: '',
          valueType:8,
          userCode:this.userCode,
          pageIndex:1,
          pageSize:2000,
        }
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {

              let arr = [];
              for(let i=response.data.data.pageInfo.list.length-1;i>=0;i--){
                let item = response.data.data.pageInfo.list[i];
                arr.push({'createTime':timefilters(item.createTime),'value':item.value});
              }

              this.chartData_total_day.rows = arr;

              this.$nextTick(() => {
                this.$refs.chartline.echarts.resize()
              })

            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )
    },

  }
}


</script>

<style lang="scss" scoped>

</style>
